import {premiumColor} from '../sass/base/_exports.sass';

export const DiamondIcon = (props) => {
  const {color = premiumColor, className = '', ratio = 1, dataId} = props;

  // default dimensions
  const width = 14;
  const height = 14;

  const style = {
    height: `${ratio * height}px`,
    width: `${ratio * width}px`,
  };

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      data-header-id={dataId}
      className={className}
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.06266 0.750001C2.98148 0.750004 2.9019 0.772594 2.83283 0.815244C2.76375 0.857894 2.70791 0.918922 2.67154 0.991501L0.921538 4.4915C0.883692 4.56686 0.86843 4.65155 0.877588 4.73537C0.886747 4.8192 0.919937 4.89859 0.973163 4.964L6.66066 11.964C6.70169 12.0145 6.75344 12.0552 6.81217 12.0831C6.8709 12.1111 6.93512 12.1256 7.00016 12.1256C7.0652 12.1256 7.12942 12.1111 7.18815 12.0831C7.24688 12.0552 7.29864 12.0145 7.33966 11.964L13.0272 4.964C13.0805 4.89868 13.1139 4.81933 13.1232 4.7355C13.1325 4.65167 13.1174 4.56694 13.0797 4.4915L11.3297 0.991501C11.2932 0.918789 11.2372 0.857673 11.168 0.815014C11.0988 0.772355 11.019 0.749841 10.9377 0.750001H3.06266ZM2.02054 4.25L3.33304 1.625H5.12679L4.47054 4.25H2.02054ZM2.23141 5.125H4.49154L5.90291 9.6435L2.23141 5.125ZM5.40766 5.125H8.59266L7.00016 10.2201L5.40766 5.125ZM9.50966 5.125H11.7689L8.09741 9.6435L9.50966 5.125ZM11.9798 4.25H9.52979L8.87354 1.625H10.6673L11.9798 4.25ZM8.62766 4.25H5.37266L6.02891 1.625H7.97141L8.62766 4.25Z"
        fill={color}
      />
    </svg>
  );
};
